import { render } from "./AddBulkUsers.vue?vue&type=template&id=19593c28"
import script from "./AddBulkUsers.vue?vue&type=script&lang=js"
export * from "./AddBulkUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__